import { useEffect, useReducer, useState } from 'react';

import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MAX_WIDTH,
  TABLET_MAX_WIDTH,
  TABLET_MIN_WIDTH,
} from '../constants/breakpoints';

export function useMatchMedia(query) {
  const [mqList, setMqList] = useState(() => matchMedia(query));
  const [, forceRender] = useReducer(s => ++s, 0);

  useEffect(() => {
    const newMqList = matchMedia(query);
    const onChange = () => forceRender();

    setMqList(newMqList);
    addListener(newMqList, onChange);

    return () => removeListener(newMqList, onChange);
  }, [query]);

  return mqList.matches;
}

export function useMatchMobileOnly() {
  return useMatchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
}

export function useMatchTabletOnly() {
  return useMatchMedia(
    `(min-width: ${TABLET_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH}px)`
  );
}

export function useMatchDesktopOnly() {
  return useMatchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`);
}

export function useMatchTabletOrDesktop() {
  return useMatchMedia(`(min-width: ${TABLET_MIN_WIDTH}px)`);
}

function addListener(mqList, callback) {
  if (mqList.addEventListener) {
    mqList.addEventListener('change', callback, { passive: true });
  } else {
    mqList.addListener(callback);
  }
}

function removeListener(mqList, callback) {
  if (mqList.removeEventListener) {
    mqList.removeEventListener('change', callback);
  } else {
    mqList.removeListener(callback);
  }
}
